import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FileTypesEnum, MediaTypesEnum } from '@shared/enums';
import { INewsDetails } from '@shared/models';

@Component({
    selector: 'anp-news-details',
    templateUrl: './news-details.component.html',
    styleUrls: ['./news-details.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NewsDetailsComponent implements OnInit {

  @Input() public news: INewsDetails;

  public date: Date = new Date();
  public mediaType = MediaTypesEnum;
  private modal: HTMLIonModalElement;
  public fileTypes = FileTypesEnum;

  public ngOnInit(): void {
    this.date = new Date(this.news.DateNews);
  }

  //method to close the modal
  public async dismiss(value = null): Promise<void> {
    await this.modal.dismiss(value);
  }

  public async goToFilter(id: number): Promise<void> {
    await this.dismiss(id);
  }
}
